export const FETCH_META_INFO = "FETCH_META_INFO"
export const FETCH_META_INFO_SUCCESS = "FETCH_META_INFO_SUCCESS"

